var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAugmentedReality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fec68bcb-daf9-47c3-8fe7-9c9aacc19b3b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .e2bf5bec-dc6b-40de-8a14-a014c782483d {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e2bf5bec-dc6b-40de-8a14-a014c782483d",
    d: "M50,8.073,28.381,14.331,29.529,39.37,50,51.927,70.471,39.37l1.148-25.039Zm14.645,7.363-14.6,4.181L35.5,15.393,50,11.2ZM31.523,17.361,48.5,22.292v25.2L32.452,37.644ZM51.5,47.487V22.322l16.972-4.861-.925,20.183Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmentedReality);
export default __webpack_public_path__ + "static/media/AugmentedReality.a69a451606814c3509856f3bb9976807.svg";
export { ForwardRef as ReactComponent };